import React, { useState } from "react";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";
import { DelayInput } from "react-delay-input/lib/Component";

import DefaultButton from "../../styles/materialButtonStyle";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../elements/filter/styledFiter";

const ServiceBalancesFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("serviceBalancesPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "serviceName": "",
    "client": "",
    "currency": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="clear-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="1">
              <StyledFilterGroup>
                <label htmlFor="serviceName">
                  {t("filter.serviceName")}
                </label>
                <DelayInput
                  id="serviceName"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "serviceName": event.target.value, page: 1 })}
                  name="serviceName"
                  value={filterData["serviceName"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ServiceBalancesFilter;